import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr'; // Ou qualquer biblioteca de notificação que você esteja usando
import {catchError, finalize, lastValueFrom, of} from 'rxjs';
import {GeoLocalizacaoService} from '../../shared/geo-localizacao/geo-localizacao.service';
import {SpinnerService} from '../../shared/services/spinner-service.service';
import {ConsultaCepService} from './consulta-cep.service';

@Injectable({
  providedIn: 'root',
})
export class CepFormService {
  constructor(
    private cepService: ConsultaCepService,
    private toastr: ToastrService,
    private _geo: GeoLocalizacaoService,
    private _spinnerService: SpinnerService,
  ) {
    this.listarTodosEstados();
  }

  listaCidades: any;
  listaEstados: any;

  async listarTodosEstados() {
    const data = await lastValueFrom(this._geo.ListStates());
    this.listaEstados = data;

    // Encontrar e mover o item "Outro" para o final da lista
    const indexOutro = this.listaEstados.findIndex((item: {name: string}) => item.name === 'Outro');

    if (indexOutro > -1) {
      const outro = this.listaEstados.splice(indexOutro, 1)[0];
      this.listaEstados.push(outro); // Adiciona "Outro" no final
    }
  }

  async listarCidadesPorIdEstado(idEstado: number) {
    if (idEstado) {
      this.listaCidades = await lastValueFrom(this._geo.ListCitiesByStates([idEstado]));
    } else {
      this.listaCidades = [];
    }
  }
  async buscarCEP(form: FormGroup) {
    const cep = form.get('adressCep')?.value || form.get('cep')?.value;
    const cityId = form.get('cityId')?.value;
    let nameCity = '';

    if (!cep || cep.trim() === '') {
      // this.resetForm(form);
      return;
    }

    const stateId = form.get('stateId')?.value;

    // Aguarda a listagem de cidades antes de buscar o CEP
    await this.listarCidadesPorIdEstado(stateId);
      this.iniciarSpinner();
      // Tenta o método original primeiro
      const data = await lastValueFrom(
        this.cepService.consultaCEP(cep).pipe(
          finalize(() => {
            this.pararSpinner();
          }),
          catchError(error => {
            // Se o principal falhar, tenta o método alternativo
            return this.cepService.consultaCEPAlternativo(cep).pipe(
              finalize(() => {
                this.pararSpinner();
              }),
              catchError(altError => {
                this.toastr.error('Erro ao consultar CEP. Verifique a conexão ou tente outro CEP.');
                return of(null);
              }),
            );
          }),
        ),
      );

      if (!data) {
        // this.resetForm(form);
        return;
      }

      if (cityId) {
        const cidadeSelecionada = this.listaCidades.find((cidade: any) => cidade.id === cityId);
        nameCity = cidadeSelecionada?.name;
      }

      if (nameCity) {
        if (data.localidade !== nameCity) {
          this.toastr.warning('O CEP informado não corresponde a essa localidade.');
          // this.resetForm(form);
          return;
        }
      }

      if (data && data.logradouro && data.bairro) {
        form.patchValue({
          adress: data.logradouro,
          adressNeighborhood: data.bairro,
          neighborhood: data.bairro,
        });
      } else {
        this.toastr.warning('Dados do CEP não encontrados.');
        // this.resetForm(form);
      }
  }

  private resetForm(form: FormGroup) {
    const fields = [
      'adress',
      'adressNeighborhood',
      'neighborhood',
      'adressCity',
      'adressState',
      'adressCountry',
      'adressNumber',
      'adressComplement',
      'stateId',
      'cityId',
      'addressType',
      'stateName',
      'cityName',
    ];

    fields.forEach(field => {
      if (form.contains(field)) {
        form.patchValue({[field]: null});
      }
    });
  }

  limparCidadeECEP(form: FormGroup) {
    form.patchValue({
      cityId: null,
      adressCep: '',
      cep: '',
      cityName: '',
      adress: '',
      adressNeighborhood: '',
      neighborhood: '',
      adressNumber: '',
      number: '',
      adressComplement: '',
      stateName: '',
    });
  }
  limparCEP(form: FormGroup) {
    form.patchValue({
      adressCep: '',
      cep: '',
      adress: '',
      adressNeighborhood: '',
      neighborhood: '',
      adressNumber: '',
      number: '',
      adressComplement: '',
      cityName: '',
    });
  }
  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
